module.exports = __webpack_public_path__ + "img/map-stops.dee0096d.svg";